// collection of endpoints goes here
const endpoints = {
  processCardPayment: '/cards/payments',
  processCardSubscription: '/cards/subscription',
  processDirectDebitSubscription: '/direct-debit/subscription',
  processCashPayment: '/cash/payments',
  paymentLink: (uuid: string): string => `/payment-links/${uuid}/checkout`,
  processSpeiPayment: '/spei/payments',
  createPaymentOrderError: '/payment-orders/errors',
  updatePayment: '/payment-links/update-payment',
  accountsPayableLink: (accountsPayableLinkId: string) =>
    `/accounts-payable/${accountsPayableLinkId}/checkout`,
  updateAccountsPayableLinkStatus: '/accounts-payable/update/status',
  requestFunds: '/accounts-payable/request-funds',
  cancelAccountsPayable: (accountsPayableLinkId: string) =>
    `/accounts-payable/${accountsPayableLinkId}`,
  // digital payments fiserv implementation
  loginDigitalPayments: '/auth',
  paymentIntents: '/payment-intents',
  cardToken: '/card/tokens',
  paymentsSecure: '/payments/secure',
  paymentsSecureContinue: '/payments/secure-continue',
  paymentIntent: (paymentIntentId: string): string => `/payment-intents/${paymentIntentId}`,
  payments: '/payments',
  //redpay
  getAuthToken: '/api/auth/Authenticate',
  getCardToken: '/api/customercardidentifiers',
  confirm3dsPaymentStatus: '/payment-links/confirm/3ds/payment',
  //porcobrar-sura
  proofPayment: '/payments/v1/proof_payment',
  sendReceipt: '/oyster/v1/sendPayment',
  bankReference: '/payments/v1/bank_reference',
  sharePaymentLink: '/oyster/v1/sendPaymentLink',
  paymentDueDate: (paymentLinkId: string): string => `/payment-links/${paymentLinkId}/dueDate`,
  logsPayment: '/logs/payment',
};

export default endpoints;
